import { ActionTypes } from "../constants/action-types";

const initialState = {
 updatedFormData: null,           // Stores the form details before submission
  submittedData: null,      // Stores the data returned after successful submission
  loading: false,           // Tracks the API request state
  error: null,              // Holds any submission error
  success: false,           // Indicates if the submission was successful
};

export const hackathonFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SAVE_HACKATHON_FORM:
      return {
        ...state,
        updatedFormData: action.payload,
        error: null,
        success: false,
      };

    case ActionTypes.SUBMIT_HACKATHON_FORM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case ActionTypes.SUBMIT_HACKATHON_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        submittedData: action.payload,
      };

    case ActionTypes.SUBMIT_HACKATHON_FORM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case ActionTypes.RESET_HACKATHON_FORM:
      return initialState;

    default:
      return state;
  }
};

export default hackathonFormReducer;
